import React from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import IconChevronDown from '../../../__generated__/Icons/IconChevronDown';
import IconClose from '../../../__generated__/Icons/IconClose';
import Paragraph from '../../../Typography/Paragraph';
import * as styles from './style.module.css';
const InnerButton = ({ hasMenu, value, label, chevronClasses, buttonClasses, ...commonProps }) => {
    return Depot.createElement('button', {
        ...commonProps,
        className: buttonClasses,
        ['aria-label']: value ? label : undefined,
    }, React.createElement(React.Fragment, null,
        React.createElement(Paragraph, { as: "span", typeStyle: "body" }, value ? value : label),
        hasMenu && (React.createElement(IconChevronDown, { className: chevronClasses, "aria-hidden": true }))));
};
const BinaryFilterButtonWithoutRef = ({ hasMenu = false, label, value, selected = false, isMenuOpen = false, buttonClearLabel = '', onClear, className, ...commonProps }) => {
    const wrapperClasses = clsx(styles.overlay);
    const buttonClasses = clsx(className, styles.button, {
        [styles.selected]: selected,
        [styles.binary]: !hasMenu,
    });
    const chevronClasses = clsx(styles.chevron, {
        [styles.active]: isMenuOpen,
        [styles.invisible]: selected,
    });
    return (React.createElement("div", { className: wrapperClasses },
        React.createElement(InnerButton, { ...commonProps, hasMenu: hasMenu, label: label, value: value, buttonClasses: buttonClasses, chevronClasses: chevronClasses }),
        hasMenu && selected && (React.createElement("button", { className: styles.overlayButton, onClick: onClear, "aria-label": buttonClearLabel },
            React.createElement(IconClose, { "aria-hidden": true })))));
};
const BinaryFilterButton = Depot.withRef(BinaryFilterButtonWithoutRef);
BinaryFilterButton.displayName = 'BinaryFilterButton';
export default BinaryFilterButton;
//# sourceMappingURL=index.js.map